import { useSelector } from 'react-redux'
import { classNames, lang } from '@/components/common/Helpers'
import GuestbookReplyItem from './GuestbookReplyItem'
import PhotoCarousel from '../photo_gallery/PhotoCarousel'
import PhotoCarouselModal from '../photo_gallery/PhotoCarouselModal'
import { useState } from 'react'
import ReactLinkify from 'react-linkify'

import moment from 'moment'

export default function GuestbookItem({ post, className, setObituaryPost }) {

    const { obituary } = useSelector((state) => state.obituaryReducer)
    const [showAllReplies, setShowAllReplies] = useState(false)
    const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalPhotoIndex, setModalPhotoIndex] = useState(0)

    const language = lang

    const toggleShowAllReplies = () => {
        setShowAllReplies((prevShowAllReplies) => !prevShowAllReplies)
    }

    const visibleReplies = showAllReplies ? post.posts : post.posts.slice(0, 2)

    // Create array of all photos for this post
    const getAllPhotos = () => {
        const photos = []

        if (post.type === 'gift') {
            if (post.obituary_post_gift_photo) {
                photos.push({
                    original: post.obituary_post_gift_photo.asset.xl,
                    thumbnail: post.obituary_post_gift_photo.asset.md,
                    originalAlt: `Gift photo: ${obituary?.display_name} posted by ${post.name}`,
                    thumbnailAlt: `Gift photo thumbnail: ${obituary?.display_name} posted by ${post.name}`,
                    type: 'gift'
                })
            }
            if (post.obituary_post_card_photo) {
                photos.push({
                    original: post.obituary_post_card_photo.asset.xl,
                    thumbnail: post.obituary_post_card_photo.asset.md,
                    originalAlt: `Card photo: ${obituary?.display_name} posted by ${post.name}`,
                    thumbnailAlt: `Card photo thumbnail: ${obituary?.display_name} posted by ${post.name}`,
                    type: 'card'
                })
            }
        } else {
            if (post.obituary_post_photos) {
                post.obituary_post_photos.forEach((asset, index) => {
                    photos.push({
                        original: asset.asset.xl,
                        thumbnail: asset.asset.md,
                        originalAlt: `Guestbook gallery photo ${index + 1}: ${obituary?.display_name} posted by ${post.name}`,
                        thumbnailAlt: `Guestbook gallery photo thumbnail ${index + 1}: ${obituary?.display_name} posted by ${post.name}`,
                        type: 'regular'
                    })
                })
            }
        }

        return photos
    }

    const photos = getAllPhotos()
    const hasPhotos = photos.length > 0

    return (
        <div className={classNames("bg-white rounded-md overflow-hidden", className)}>
            {/* Show photos with carousel */}
            {hasPhotos && obituary && (
                <div className="relative cursor-pointer overflow-hidden" onClick={() => {
                    setModalPhotoIndex(currentPhotoIndex)
                    setIsModalOpen(true)
                }}>
                    <div className="relative w-full bg-black overflow-hidden" style={{ aspectRatio: '4/3', maxHeight: '320px' }}>
                        <PhotoCarousel
                            photos={photos}
                            currentPhotoIndex={currentPhotoIndex}
                            setCurrentPhotoIndex={setCurrentPhotoIndex}
                            showTypeLabel={true}
                            animationType="slide"
                            showBackgroundBlur={true}
                            navigationSize="small"
                            maxHeight="320px"
                            showIndex={false}
                            maxDots={10}
                            zIndex={5}
                        />
                    </div>
                </div>
            )}

            <div className={classNames("text-sm p-6 leading-6", !post.formatted_message && "pb-0")}>
                {post.assetable_id_candle &&
                    <img loading='lazy' src={post.candle_url} className={classNames("float-left mb-2 mr-4", post.formatted_message ? "w-20 h-20" : "w-10 h-10")} />
                }
                <p className="whitespace-pre-wrap">
                    <ReactLinkify
                        componentDecorator={(decoratedHref, decoratedText, key) => (
                            <a
                                href={decoratedHref}
                                className="text-blue-500 break-all"
                                target="_blank"
                                rel="noopener"
                                key={key}
                            >
                                {decoratedText}
                            </a>
                        )}
                    >
                        <span dangerouslySetInnerHTML={{ __html: post.formatted_message }} />
                    </ReactLinkify>
                </p>
            </div>
            <div className="px-6 pb-6 text-sm">
                <p className="text-blue-800 uppercase font-bold">{post.name}</p>
                <p className="text-gray-400">{moment(post.submitted_at).toDate().toLocaleDateString(language, {
                    day: '2-digit',
                    year: 'numeric',
                    month: 'short',
                })}</p>
            </div>

            {post.posts?.length > 0 && (
                <div className={classNames("border-t p-6 bg-gray-200")}>
                    <p className="text-xs text-gray-800 font-bold pb-2">
                        {post.posts.length} {post.posts.length === 1 ? "Reply" : "Replies"}:
                    </p>

                    {visibleReplies.map(childPost =>
                        <GuestbookReplyItem
                            key={childPost.id}
                            post={childPost}
                            setObituaryPost={setObituaryPost}
                        />
                    )}
                    {post.posts.length > 2 && (
                        <button
                            onClick={toggleShowAllReplies}
                            className="bg-grey-100 text-blue-500 my-2 ml-4 text-xs hover:text-blue-600"
                        >
                            {showAllReplies ? "Show Less Replies" : "Show All Replies"}
                        </button>
                    )}

                </div>
            )}

            {/* Modal for full-screen carousel */}
            {isModalOpen && (
                <PhotoCarouselModal
                    photos={photos}
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    currentPhotoIndex={modalPhotoIndex}
                    setCurrentPhotoIndex={(index) => {
                        setModalPhotoIndex(index)
                        setCurrentPhotoIndex(index)
                    }}
                    showPhotoCounter={true}
                    showTypeLabel={true}
                    animationType="fade"
                    maxDots={7}
                    navigationSize="large"
                    showBackgroundBlur={true}
                />
            )}
        </div>
    )
}
